// Quem pode trocar o responsável de uma negociação no CRM — o campo
// "Responsável" do detalhe e a seleção em massa da visão de tabela.
//
// adm e gerente transferem pelo papel. Para mais alguém, a concessão é nominal
// (Config > Usuários > Permissões Especiais). Criada em 19/10/2026 para a Júlia
// Cintra (Closer, papel `analista`), que repassa leads para os vendedores.
//
// Quem supervisiona o Comercial (#6521) também transfere, mas só entre Closers,
// BDRs e ele mesmo — ver transferenciaRestritaAEquipe e supervisaoComercial.ts.
//
// ⚠️ Isto é só UX. A RLS de `negociacoes` deixa qualquer usuário logado alterar
// o responsável (policy "Authenticated users can update negotiations", com
// `true`), então a tela é a única barreira hoje.
import { supervisionaComercial } from './supervisaoComercial.ts';

export const TRANSFERIR_NEGOCIACOES_PERMISSION = 'Transferir negociações';

type PerfilTransferencia = { role?: string | null; status?: string | null; permissions?: string[] | null } | null | undefined;

/** Transfere sem restrição de destino: adm, gerente ou a permissão "Transferir negociações". */
const transfereLivre = (perfil: PerfilTransferencia): boolean => {
  if (!perfil) return false;
  if (perfil.role === 'adm' || perfil.role === 'gerente') return true;
  return !!perfil.permissions?.includes(TRANSFERIR_NEGOCIACOES_PERMISSION);
};

export function podeTransferirNegociacao(perfil: PerfilTransferencia): boolean {
  return transfereLivre(perfil) || supervisionaComercial(perfil);
}

/** A lista de destino da transferência fica só com Closers, BDRs e a própria pessoa? */
export function transferenciaRestritaAEquipe(perfil: PerfilTransferencia): boolean {
  return !transfereLivre(perfil) && supervisionaComercial(perfil);
}
